var map = {
	"./1.jpg": 6173,
	"./2.png": 4998,
	"./3.jpg": 4751,
	"assets/TopHeroImages/1.jpg": 6173,
	"assets/TopHeroImages/2.png": 4998,
	"assets/TopHeroImages/3.jpg": 4751
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5661;